import { createContext } from 'preact';

const GlobalContext = createContext({
  pathroot: '',
  retailer: null,
  enableanalytics: 'true',
  primaryDomain: null,
  privacylink: '',
});

export default GlobalContext;
